import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar/AppBar';
import { CSSObject, styled, Theme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import { EXPORT, HOME, USERLIST } from '../../../routes/paths';
import { ModulesMessages } from '../../../shared/messages/modulesMessages';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import DownloadIcon from '@mui/icons-material/Download';

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

export const drawerWidth = 230;

export const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    height: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
});

export const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    height: '100%',
    width: `calc(${theme.spacing(9)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(10)} + 1px)`,
    },
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
});

export const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

export const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    borderColor: theme.palette.primary.main,
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
    }),
}));

export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        borderColor: theme.palette.primary.main,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const { HOME_MODULE, USERS_MODULE, EXPORT_MODULE } = ModulesMessages;

export const ModulesSideBar = [
    {
        route: HOME,
        label: HOME_MODULE,
        icon: <HomeRoundedIcon sx={{ color: 'primary.main' }} />,
    },
    {
        route: USERLIST,
        label: USERS_MODULE,
        icon: <PeopleAltRoundedIcon sx={{ color: 'primary.main' }} />,
        permissions: ['admin'],
    },
    {
        route: EXPORT,
        label: EXPORT_MODULE,
        icon: <DownloadIcon sx={{ color: 'primary.main' }} />,
        permissions: ['admin'],
    },
];
